import React from "react";
import { useQuery } from "@tanstack/react-query";
import { Layout } from "../components/Layout";
import { useI18n } from "../i18n";
import * as apiClient from "../api";

export default function Guides() {
  const { t } = useI18n();
  const { data: guides = [] } = useQuery({ queryKey: ["content"], queryFn: apiClient.getContent });
  return (
    <Layout>
      <div className="bg-gradient-to-b from-slate-50 to-white border-b border-slate-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10">
          <div className="text-xs font-bold uppercase tracking-[0.2em] text-secondary mb-2">Guide & Blog</div>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-heading font-semibold tracking-tight text-slate-900">Ispirazione per la tua vacanza</h1>
          <p className="text-slate-500 mt-2">Consigli, itinerari e cose da fare a Vieste e nel Gargano.</p>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {guides.map((g) => (
            <div key={g.id} data-testid={`guide-${g.id}`} className="group rounded-2xl overflow-hidden border border-slate-100 shadow-sm hover-lift cursor-pointer">
              <div className="relative h-52 overflow-hidden">
                <img src={g.image} alt={g.title} className="h-full w-full object-cover img-zoom" loading="lazy" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent" />
                <span className="absolute top-3 left-3 rounded-full bg-white/90 px-3 py-1 text-xs font-semibold text-primary capitalize">{g.category}</span>
                <h3 className="absolute bottom-3 left-4 right-4 text-white font-heading font-semibold text-lg leading-tight drop-shadow">{g.title}</h3>
              </div>
              <div className="p-5"><p className="text-sm text-slate-500">{g.excerpt}</p></div>
            </div>
          ))}
        </div>
      </div>
    </Layout>
  );
}
